<template>
    <div class="card-box m-b-5 p-10 card_color_left" :style="`border-left-color: ${getSegmentColor(record.segment)}`" v-pml-block="inlineUpdating">
        <div class="table-box table_fixed">

            <!-- Infos Lead/Deal -->
            <div class="table-detail">
                <div class="member-info">
                    <h5 class="m-t-0 m-b-5 bold">
                        <a href="javascript:;" @click="showDetails = !showDetails" v-pml-tooltip.top-right="$t('info')" v-if="hasDetails"><i class="fa-fw fa fa-info-circle"></i></a>
                        <span v-if="record.first_name && !record.lead">{{ record.full_name }}</span>
                        <a :href="`/leads/${record.lead.id}`" target="_blank" v-if="record.first_name && record.lead">{{ record.full_name }}</a>
                    </h5>
                    <small class="show t_overflow m-b-5 bold" v-if="record.email">{{ record.email }}</small>
                    <small class="show t_overflow">{{ record.created_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                </div>

                <!-- Status incoming -->
                <label class="d_inline_b label label-light m-t-5 m-b-0 t_overflow" v-if="record.closed_by">{{ $t('closed_by') }} {{ record.closed_by.full_name }} {{ $t('at') }} {{ record.closed_at | pmlDate('DD/MM/YYYY HH:mm') }}</label>
                <label class="d_inline_b label label-danger m-t-5 m-b-0 t_overflow" v-if="record.comparison">{{ $t(record.comparison) }}</label>

            </div>

            <div class="table-detail">
                <div class="row">

                    <!-- Consultant -->
                    <div class="col-xs-12 col-sm-6 col-md-12 m-b-4">
                        <div v-if="consultantEditing">
                            <div class="input-group m-b-5">
                                <span class="input-group-addon d_t_cell w_30" v-pml-tooltip.top-right="$t('consultant')"><i class="md-headset-mic"></i></span>
                                <pml-select-members v-model="record.member_id" :only-active="true" @input="inlineUpdate" :remove-from-options="record.follower_id"></pml-select-members>
                                <a class="btn btn-danger d_t_cell w_30" v-pml-tooltip="$t('cancel')" v-if="record.member" @click="consultantEditing = false"><i class="fa fa-times"></i></a>
                            </div>
                        </div>

                        <span class="link_muted text-muted" @click="consultantEditing = true" v-pml-tooltip="$t('consultant')" v-if="record.member && !consultantEditing">
                            <i class="md-headset-mic text-dark m-r-5"></i> {{ record.member.full_name }}
                            <i class="fa fa-pencil"></i>
                        </span>

                    </div>

                    <!-- Follower -->
                    <div class="col-xs-12 col-sm-6 col-md-12 m-b-4">
                        <div v-if="followerEditing">
                            <div class="input-group m-b-5">
                                <span class="input-group-addon d_t_cell w_30" v-pml-tooltip.top-right="$t('follower')"><i class="fa fa-location-arrow"></i></span>
                                <pml-select-members v-model="record.follower_id" :only-follow="true" @input="inlineUpdate" :remove-from-options="record.member_id"></pml-select-members>
                                <a class="btn btn-danger d_t_cell w_30" v-pml-tooltip="$t('cancel')" v-if="record.follower" @click="followerEditing = false"><i class="fa fa-times"></i></a>
                            </div>
                        </div>

                        <span class="link_muted text-muted" v-pml-tooltip="$t('follower')" @click="followerEditing = true" v-if="record.follower && !followerEditing">
                            <i class="fa-fw fa fa-location-arrow text-dark m-r-5"></i> {{ record.follower.full_name }}
                            <i class="fa fa-pencil"></i>
                        </span>

                    </div>

                </div>
            </div>
            <div class="table-detail t_center">
                <div class="row">

                    <!-- Country -->
                    <div class="col-xs-12 col-sm-6 col-md-12 m-b-7" v-if="record.country_id">
                        <p class="text-muted m-b-5 d_inline_b">
                            <img :src="`/static/images/flags/${record.country.acronym}.png`" :alt="record.country.name" class="flag_deal"> {{ record.country.name }}
                        </p>
                    </div>

                    <!-- Source -->
                    <div class="col-xs-12 col-sm-6 col-md-12 m-b-7" v-if="record.source_id">
                        <span class="label label-default" :style="`background-color:${record.source.color}`" v-pml-tooltip="$t('source')" >{{ record.source.name }}</span>
                    </div>

                    <!-- Pipeline -->
                    <div class="col-xs-12">
                        <div class="input-group m_0_auto" v-if="pipelineEditing">
                            <span class="input-group-addon d_t_cell w_30" v-pml-tooltip.top-right="$t('pipeline')"><i class="fa fa-toggle-right"></i></span>
                            <pml-select-group v-model="record.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline" @input="inlineUpdate"></pml-select-group>
                            <a class="btn btn-danger d_t_cell w_30" v-pml-tooltip="$t('cancel')" v-if="record.pipeline_step_id" @click="pipelineEditing = false"><i class="fa fa-times"></i></a>
                        </div>

                        <small class="link_muted text-muted" @click="pipelineEditing = true" v-if="record.step && !pipelineEditing" v-pml-tooltip="$t('pipeline')">
                            <i class="fa-fw fa fa-toggle-right text-dark m-r-5"></i> {{ record.step.pipeline.name }} <i class="fa fa-long-arrow-right"></i> {{ record.step.name }}
                            <i class="fa fa-pencil"></i>
                        </small>
                    </div>

                </div>
            </div>

            <!-- Status -->
            <div class="table-detail table_divider_mobile t_center w_100">
                <label class="label" :class="`${getStatusClass(record.status)}`" v-pml-tooltip="$t('status')">{{ $t(record.status) }}</label>
            </div>

            <!-- Actions -->
            <div class="table-detail table_divider_mobile table-actions-bar t_center w_80">
                <div class="m-b-5">
                    <button class="btn btn-inverse btn-xs" @click="showDetails = !showDetails" v-pml-tooltip="$t('info')" v-if="hasDetails"><i class="fa-fw fa fa-info-circle"></i></button>
                    <button class="btn btn-white btn-xs" v-pml-tooltip="$t('compare')" @click.prevent="compare()" v-if="record.email" v-pml-block="isComparing"><i class="fa-fw fa fa-exchange"></i></button>
                </div>
                <button class="btn btn-default btn-xs" v-pml-tooltip="$t('approve')" @click.prevent="askToAccept()" v-if="record.status == 'pending'" v-pml-block="isAccepting"><i class="fa-fw fa fa-check"></i></button>
                <button class="btn btn-danger btn-xs" v-pml-tooltip="$t('refuse')" @click.prevent="askToRefuse()" v-if="record.status == 'pending'" v-pml-block="isRefusing"><i class="fa-fw fa fa-ban"></i></button>
            </div>

        </div>

        <!-- Info Lead PML -->
        <div v-if="record.lead">
            <hr class="m-t-10 m-b-10">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <a :href="`/leads/${record.lead.id}`" class="btn btn-sm btn-primary" target="_blank"><i class="ti-user m-r-5"></i> {{ $t('see_lead') }}</a>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <div class="m-t-5 t_right">
                        <b class="m-r-10">{{ $t('deals') }}:</b>
                        <label class="label label-warning" v-pml-tooltip="$t('open_as')"><i class="fa-fw fa fa-coffee"></i> {{ record.lead.deals_counter.open }}</label>
                        <label class="label label-default" v-pml-tooltip="$t('sold_as')"><i class="fa-fw fa fa-thumbs-up"></i> {{ record.lead.deals_counter.sold }}</label>
                        <label class="label label-danger" v-pml-tooltip="$t('lost_as')"><i class="fa-fw fa fa-thumbs-down"></i> {{ record.lead.deals_counter.lost }}</label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Show more informations -->
        <div v-if="showDetails">
            <hr class="m-t-10 m-b-10">
            <div class="p-l-10 p-r-10" v-if="hasDetails">
                <blockquote class="m-0">
                    <div class="show" v-if="record.phone"><strong>{{ $t('phone') }}: </strong>{{ record.phone }}</div>
                    <div class="show" v-if="record.mobile"><strong>{{ $t('mobile') }}: </strong>{{ record.mobile }}</div>
                    <div class="show" v-if="record.reference"><strong>{{ $t('reference') }}: </strong>{{ record.reference }}</div>
                    <div class="show" v-if="record.interests"><strong>{{ $t('interests') }}: </strong>{{ record.interests }}</div>
                    <div class="show" v-if="record.address"><strong>{{ $t('address') }}: </strong>{{ record.address }}</div>
                    <div class="show" v-if="record.complement"><strong>{{ $t('complement') }}: </strong>{{ record.complement }}</div>
                    <div class="show" v-if="record.district"><strong>{{ $t('district') }}: </strong>{{ record.district }}</div>
                    <div class="show" v-if="record.city"><strong>{{ $t('city') }}: </strong>{{ record.city }}</div>
                    <div class="show" v-if="record.state"><strong>{{ $t('state') }}: </strong>{{ record.state }}</div>
                    <div class="show" v-if="record.zip_code"><strong>{{ $t('zip_code') }}: </strong>{{ record.zip_code }}</div>
                    <div class="show" v-if="record.skype"><strong>{{ $t('skype') }}: </strong>{{ record.skype }}</div>
                    <div class="show" v-if="record.facebook"><strong>{{ $t('facebook') }}: </strong>{{ record.facebook }}</div>
                    <div class="show" v-if="record.instagram"><strong>{{ $t('instagram') }}: </strong>{{ record.instagram }}</div>
                    <div class="show" v-if="record.twitter"><strong>{{ $t('twitter') }}: </strong>{{ record.twitter }}</div>
                    <div class="show" v-if="record.pinterest"><strong>{{ $t('pinterest') }}: </strong>{{ record.pinterest }}</div>
                    <div class="show" v-if="record.linkedin"><strong>{{ $t('linkedin') }}: </strong>{{ record.linkedin }}</div>
                    <div class="show" v-if="record.gplus"><strong>{{ $t('gplus') }}: </strong>{{ record.gplus }}</div>
                    <div class="show" v-if="record.site"><strong>{{ $t('site') }}: </strong>{{ record.site }}</div>
                    <div class="show" v-if="record.comments"><strong>{{ $t('comments') }}: </strong><span v-html="comments"></span></div>
                </blockquote>
            </div>
        </div>

    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { irreversible } from 'utils/helpers/sweet-alert'
    import { refuse, accept, update } from 'services/incoming'
    import { mapGetters } from 'vuex'
    import { cloneDeep, isNil } from 'lodash'

    export default {
        name: 'IncomingItem',
        props: {
            item: {
                type: Object,
                default: () => {}
            }
        },
        data () {
            return {
                record: {},
                isComparing: false,
                isAccepting: false,
                isRefusing: false,
                showDetails: false,
                inlineUpdating: false,
                consultantEditing: false,
                followerEditing: false,
                pipelineEditing: false
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'pipelines': 'getPipelines'
            }),
            hasDetails () {
                return !isNil(this.record.phone) ||
                    !isNil(this.record.mobile) ||
                    !isNil(this.record.reference) ||
                    !isNil(this.record.interests) ||
                    !isNil(this.record.comments) ||
                    !isNil(this.record.address) ||
                    !isNil(this.record.complement) ||
                    !isNil(this.record.district) ||
                    !isNil(this.record.city) ||
                    !isNil(this.record.state) ||
                    !isNil(this.record.zip_code) ||
                    !isNil(this.record.skype) ||
                    !isNil(this.record.facebook) ||
                    !isNil(this.record.instagram) ||
                    !isNil(this.record.twitter) ||
                    !isNil(this.record.pinterest) ||
                    !isNil(this.record.linkedin) ||
                    !isNil(this.record.gplus) ||
                    !isNil(this.record.site)
            },
            comments () {
                return this.$options.filters.pmlNl2br(this.record.comments) || ''
            }
        },
        mounted () {
            this.record = cloneDeep(this.item)
        },
        watch: {
            item (val) {
                this.record = cloneDeep(val)
            },
            'record.member_id' (val) {
                this.consultantEditing = isNil(val)
            },
            'record.follower_id' (val) {
                this.followerEditing = isNil(val)
            },
            'record.pipeline_step_id' (val) {
                this.pipelineEditing = isNil(val)
            }
        },
        methods: {
            askToAccept () {
                irreversible()
                    .then((response) => (response.value) ? this.accept() : null)
            },
            askToRefuse () {
                irreversible()
                    .then((response) => (response.value) ? this.refuse() : null)
            },
            refuse () {
                if (this.record.status !== 'pending') return

                this.isRefusing = true

                refuse(this.item.id)
                    .then(response => {
                        this.record = response.data
                        bus.$emit('decreaseDeals')
                    })
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isRefusing = false })
            },
            accept () {
                if (this.record.status !== 'pending') return

                this.isAccepting = true

                accept(this.item.id)
                    .then(response => {
                        this.record = response.data
                        bus.$emit('decreaseDeals')
                    })
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isAccepting = false })
            },
            inlineUpdate () {
                this.inlineUpdating = true

                update(this.item.id, this.record)
                    .then(response => {
                        this.record = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => {
                        this.inlineUpdating = false
                        this.consultantEditing = isNil(this.record.member_id)
                        this.pipelineEditing = isNil(this.record.pipeline_step_id)
                        this.followerEditing = isNil(this.record.follower_id)
                    })
            },
            getSegmentColor (segment) {
                return segment ? segment.color : ''
            },
            getStatusClass (status) {
                if (status === 'pending') return 'label-warning'
                if (status === 'accepted') return 'label-default'
                if (status === 'refused') return 'label-danger'
                return 'label-inverse'
            },
            compare () {
                bus.$emit('emailCompareIncoming', this.item.email)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/list/Item.vue